<template>
  <div class="activity-hub">
    <section class="hero-card pk-promotion-hero">
      <div class="pk-promotion-kicker"><span></span>福利箱子</div>
      <div class="pk-promotion-showcase">
        <div class="pk-promotion-case">
          <span class="pk-promotion-spark spark-one"></span>
          <span class="pk-promotion-spark spark-two"></span>
          <img :src="welfareBoxImage(featuredWelfare)" alt="" />
          <span class="pk-promotion-price">{{ featuredWelfare.threshold_amount || 0 }}<i></i></span>
        </div>
        <div class="pk-promotion-copy">
          <span>限时福利</span>
          <h1>{{ featuredWelfare.name || "福利箱暂未开放" }}</h1>
          <p>{{ featuredWelfare.reward_name || "福利箱开放后，将在此展示可参与的奖励与领取状态。" }}</p>
          <div class="pk-promotion-meta">
            <b>本周累计充值 {{ weeklyRecharge }} 披萨币</b>
            <em>{{ syncText }}</em>
          </div>
        </div>
        <button
          class="pk-promotion-join"
          :disabled="!featuredWelfare.claimable"
          @click="featuredWelfare.id ? claimWelfare(featuredWelfare) : goPath('/task-center')"
        >{{ featuredWelfare.claimed ? "今日已开启" : featuredWelfare.claimable ? "开启" : "查看福利" }}</button>
      </div>
      <div class="pk-deposit-banner">
        <div><span>充值加赠</span><strong>{{ rechargeActivities.length ? "当前加赠活动已开启" : "充值后可获得额外奖励" }}</strong></div>
        <p>{{ rechargeActivities.length ? activityDesc(rechargeActivities[0]) : "活动资格和加赠比例以当前活动页面展示为准。" }}</p>
        <button @click="goPath('/Payment')">获取它</button>
      </div>
    </section>

    <section class="quick-grid">
      <button
        v-for="item in quickActions"
        :key="item.title"
        class="quick-card"
        :class="item.theme"
        @click="goPath(item.path)"
      >
        <span
          class="quick-icon"
          :style="{
            WebkitMaskImage: 'url(' + item.icon + ')',
            maskImage: 'url(' + item.icon + ')',
          }"
        ></span>
        <strong>{{ item.title }}</strong>
        <em>{{ item.desc }}</em>
      </button>
    </section>

    <section class="welfare-section">
      <div class="section-title">
        <span></span>
        <div>
          <h2>周福利箱</h2>
          <p>本周累计充值 {{ weeklyRecharge }} 披萨币，每周一重置；达到条件后每个已启用福利箱每天可开启一次。</p>
        </div>
      </div>
      <div v-if="welfareBoxes.length" class="welfare-grid">
        <article v-for="box in welfareBoxes" :key="box.id" class="welfare-box" :class="{ ready: box.claimable, claimed: box.claimed }">
          <img :src="welfareBoxImage(box)" alt="" />
          <div><strong>{{ box.name }}</strong><span>本周充值 {{ box.threshold_amount }} 披萨币</span><em>{{ box.reward_name }}</em></div>
          <button :disabled="!box.claimable" @click="claimWelfare(box)">{{ welfareBoxStatus(box) }}</button>
        </article>
      </div>
      <div v-else class="empty-card">当前暂无可参与的周福利箱，请留意后续活动。</div>
    </section>

    <section class="welfare-tier-section">
      <div class="section-title">
        <span></span>
        <div>
          <h2>福利箱档位</h2>
          <p>充值累计每周一重置，按当周累计充值展示 50 / 100 / 500 / 1000 / 5000 五个饰品箱档位；达到条件后，每个已启用档位每天可开启一次。</p>
        </div>
      </div>
      <div class="welfare-tier-grid">
        <article v-for="tier in welfareTiers" :key="tier.amount" :class="{ reached: loggedIn && weeklyRechargeNumber >= tier.amount }" tabindex="0">
          <span>{{ tier.name }}</span>
          <div class="welfare-tier-art">
            <img class="welfare-tier-bg" :src="tier.background" alt="" />
            <img class="welfare-tier-case" :src="tier.image" alt="" />
          </div>
          <strong>{{ tier.amount }} 披萨币</strong>
          <em>{{ welfareTierStatus(tier) }}</em>
          <div class="welfare-tier-preview">
            <b>箱内饰品与概率</b>
            <div v-if="welfareTierSkins(tier).length" class="welfare-tier-skins">
              <span v-for="skin in welfareTierSkins(tier)" :key="skin.id">
                <img :src="skin.imageUrl" alt="" />
                <i>{{ skin.itemName }}</i>
                <strong>{{ Number(skin.probability || 0).toFixed(2) }}%</strong>
              </span>
            </div>
            <p v-else>当前档位暂未配置饰品</p>
          </div>
        </article>
      </div>
    </section>

    <section class="promo-section">
      <div class="section-title">
        <span></span>
        <h2>充值加赠</h2>
      </div>
      <div v-if="rechargeActivities.length" class="promo-list">
        <article
          v-for="activity in rechargeActivities"
          :key="activity.id"
          class="promo-card"
        >
          <div>
            <span class="hot-dot"></span>
            <strong>{{ activity.name || "充值加赠活动" }}</strong>
            <p>{{ activityDesc(activity) }}</p>
          </div>
          <button @click="goPath('/Payment')">去充值</button>
        </article>
      </div>
      <div v-else class="empty-card">
        暂无进行中的充值加赠，请留意后续活动。
      </div>
    </section>

    <section class="reward-layout">
      <article class="reward-block sign-block">
        <div class="block-head">
          <span>每日签到</span>
          <h3>签到奖励</h3>
        </div>
        <div class="sign-summary">
          <strong>{{ signDays }}</strong>
          <em>本月累计签到天数</em>
        </div>
        <div class="reward-row" v-for="item in signRewards" :key="item.id">
          <span>累计 {{ item.day }} 天</span>
          <strong>{{ item.reward }} <i></i></strong>
          <em :class="statusClass(item.status)">{{ statusText(item.status) }}</em>
        </div>
      </article>

      <article class="reward-block">
        <div class="block-head">
          <span>打开箱子</span>
          <h3>打开箱子消费任务</h3>
        </div>
        <div class="reward-row" v-for="item in openboxRewards" :key="item.id">
          <span>消费 {{ item.lim }} 披萨币</span>
          <strong>{{ item.min }} - {{ item.max }} <i></i></strong>
          <em :class="statusClass(item.status)">
            {{ taskProgress(item, "lim") }}
          </em>
        </div>
      </article>

      <article class="reward-block">
        <div class="block-head">
          <span>对战</span>
          <h3>对战消费任务</h3>
        </div>
        <div class="reward-row" v-for="item in battleRewards" :key="item.id">
          <span>消费 {{ item.lim }} 披萨币</span>
          <strong>{{ item.min }} - {{ item.max }} <i></i></strong>
          <em :class="statusClass(item.status)">
            {{ taskProgress(item, "lim") }}
          </em>
        </div>
      </article>

      <article class="reward-block">
        <div class="block-head">
          <span>充值补给</span>
          <h3>充值补给</h3>
        </div>
        <div class="reward-row" v-for="item in supplyRewards" :key="item.id">
          <span>充值 {{ item.upgrade }} 披萨币</span>
          <strong>{{ item.reward }} <i></i></strong>
          <em :class="statusClass(item.status)">
            {{ taskProgress(item, "upgrade") }}
          </em>
        </div>
      </article>
    </section>

    <section class="notice-card">
      <div>
        <span class="hot-dot cyan"></span>
        <strong>cdk</strong>
        <p>cdk 兑换入口位于充值页的“cdk”标签，请以页面提示和账户记录为准。</p>
      </div>
      <button @click="goPath('/Payment?type=cdk')">打开 cdk 入口</button>
    </section>

    <div v-if="openResult" class="welfare-result-mask" @click.self="openResult = null">
      <section class="welfare-result-card">
        <button class="welfare-result-close" @click="openResult = null">×</button>
        <span>福利箱开启成功</span>
        <img :src="openResult.image_url" alt="" />
        <h3>{{ openResult.name }}</h3>
        <p>价值 {{ openResult.price }} 披萨币，饰品已进入背包。</p>
        <div><button @click="goPath('/Dota')">查看背包</button><button class="muted" @click="openResult = null">继续浏览</button></div>
      </section>
    </div>
  </div>
</template>

<script>
import { playUiSound } from "@/utils/pizzaSound";

export default {
  data() {
    const iconOpenCase = require("@/assets/pizzaking/icon-open-case.svg");
    const iconBattle = require("@/assets/pizzaking/icon-battle.svg");
    const iconCdk = require("@/assets/pizzaking/icon-cdk.svg");
    const iconTask = require("@/assets/pizzaking/icon-task-center.svg");
    return {
      syncText: "活动进度同步中",
      rechargeActivities: [],
      signDays: 0,
      signRewards: [],
      openboxRewards: [],
      battleRewards: [],
      supplyRewards: [],
      welfareBoxes: [],
      openResult: null,
      weeklyRecharge: "0.00",
      welfareImage: "/img/pizzaking/columns/welfare.png",
      welfareTiers: [
        { name: "甜甜圈福利箱", amount: 50, image: "/img/pizzaking/welfare/donut-case.png", background: "/img/pizzaking/welfare/donut-bg.png" },
        { name: "可乐福利箱", amount: 100, image: "/img/pizzaking/welfare/cola-case.png", background: "/img/pizzaking/welfare/cola-bg.png" },
        { name: "薯条福利箱", amount: 500, image: "/img/pizzaking/welfare/fries-case.png", background: "/img/pizzaking/welfare/fries-bg.png" },
        { name: "热狗福利箱", amount: 1000, image: "/img/pizzaking/welfare/hotdog-case.png", background: "/img/pizzaking/welfare/hotdog-bg.png" },
        { name: "汉堡福利箱", amount: 5000, image: "/img/pizzaking/welfare/burger-case.png", background: "/img/pizzaking/welfare/burger-bg.png" },
      ],
      quickActions: [
        {
          title: "任务中心",
          desc: "签到、打开箱子、箱子战斗、充值补给统一领取",
          path: "/task-center",
          icon: iconTask,
          theme: "orange",
        },
        {
          title: "箱子战斗",
          desc: "对战消费会同步到每日对战任务",
          path: "/Lucky",
          icon: iconBattle,
          theme: "cyan",
        },
        {
          title: "打开箱子大厅",
          desc: "打开箱子消费会同步到盲盒任务",
          path: "/Index",
          icon: iconOpenCase,
          theme: "green",
        },
        {
          title: "cdk",
          desc: "在充值页兑换 cdk",
          path: "/Payment?type=cdk",
          icon: iconCdk,
          theme: "pink",
        },
      ],
    };
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
    weeklyRechargeNumber() {
      return Number(this.weeklyRecharge || 0);
    },
    totalRewardCount() {
      return (
        this.signRewards.length +
        this.openboxRewards.length +
        this.battleRewards.length +
        this.supplyRewards.length
      );
    },
    featuredWelfare() {
      return this.welfareBoxes[0] || {};
    },
  },
  mounted() {
    this.loadActivityHub();
    this.loadWelfareBoxes();
  },
  methods: {
    welfareTierStatus(tier) {
      const box = this.welfareTierBox(tier);
      if (box && box.claimed) {
        return "今日已开启";
      }
      if (!this.loggedIn) {
        return "登录后同步本周充值";
      }
      if (!box) {
        return "待启用";
      }
      if (Number(box.status) !== 1) {
        return "待启用";
      }
      return this.weeklyRechargeNumber >= tier.amount ? "当前档位可开启" : "等待本周累计充值";
    },
    welfareBoxStatus(box) {
      if (Number(box.status) !== 1) return "未开放";
      if (box.claimed) return "今日已开启";
      return box.claimable ? "开启" : "未达成";
    },
    welfareTierBox(tier) {
      return this.welfareBoxes.find((box) => Number(box.threshold_amount) === Number(tier.amount));
    },
    welfareTierSkins(tier) {
      const box = this.welfareTierBox(tier);
      return box && Array.isArray(box.preview_skins) ? box.preview_skins : [];
    },
    welfareBoxImage(box) {
      if (box && box.image_url) {
        return box.image_url;
      }
      const tier = this.welfareTiers.find((item) => Number(item.amount) === Number(box && box.threshold_amount));
      return tier ? tier.image : this.welfareImage;
    },
    async loadActivityHub() {
      if (!localStorage.getItem("token")) {
        this.syncText = "登录后同步进度";
        return;
      }
      const params = {
        player_id: localStorage.getItem("id"),
      };
      const load = (url) =>
        this.$axios
          .post(url, this.$qs.stringify(params))
          .catch(() => ({ data: { status: 0, data: {} } }));
      const [recharge, sign, openbox, battle, supply] = await Promise.all([
        load("/index/User/giveAboutRecharge"),
        load("/index/User/sign"),
        load("/index/Activity/openbox_reward_info"),
        load("/index/Activity/battle_reward_info"),
        load("/index/Activity/czls_info"),
      ]);

      if (recharge.data.status == 1) {
        this.rechargeActivities = recharge.data.data.recharge_activity;
      }
      if (sign.data.status == 1 && sign.data.data) {
        this.signDays = sign.data.data.list[0].sign;
        this.signRewards = sign.data.data.info;
      }
      if (openbox.data.status == 1 && openbox.data.data) {
        this.openboxRewards = openbox.data.data.info;
      }
      if (battle.data.status == 1 && battle.data.data) {
        this.battleRewards = battle.data.data.info;
      }
      if (supply.data.status == 1 && supply.data.data) {
        this.supplyRewards = supply.data.data;
      }
    },
    loadWelfareBoxes() {
      this.$axios.post("/index/Welfare_box/boxList", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.welfareBoxes = res.data.data.list || [];
          this.weeklyRecharge = res.data.data.recharge_amount || "0.00";
        }
      });
    },
    claimWelfare(box) {
      if (!localStorage.getItem("token")) {
        this.$store.commit("getLogin", true);
        return;
      }
      this.$axios.post("/index/Welfare_box/open", this.$qs.stringify({ box_id: box.id })).then((res) => {
        if (res.data.status == 1) {
          playUiSound("reward");
          if (res.data.data && res.data.data.skin) {
            this.openResult = res.data.data.skin;
          } else {
            this.$message.success(res.data.msg || "开启成功");
          }
          this.loadWelfareBoxes();
          this.$root.$emit("refresh-user");
        } else {
          this.$message.error(res.data.msg || "开启失败");
        }
      });
    },
    goPath(path) {
      this.$router.push(path);
    },
    activityDesc(activity) {
      if (activity.money > 0 && activity.limit > 0) {
        return `单笔充值 ${activity.money} 至 ${activity.limit} 披萨币，多送 ${activity.billie}%`;
      }
      if (activity.money > 0) {
        return `单笔充值 ${activity.money} 披萨币起，多送 ${activity.billie}%`;
      }
      if (activity.limit > 0) {
        return `单笔充值 ${activity.limit} 披萨币以内，多送 ${activity.billie}%`;
      }
      return `单笔充值多送 ${activity.billie}%`;
    },
    statusText(status) {
      if (status == 1) {
        return "可领取";
      }
      if (status == 2) {
        return "已领取";
      }
      return "未达成";
    },
    statusClass(status) {
      if (status == 1) {
        return "ready";
      }
      if (status == 2) {
        return "done";
      }
      return "locked";
    },
    taskProgress(item, needKey) {
      if (item.status == 1) {
        return "可领取";
      }
      if (item.status == 2) {
        return "已领取";
      }
      return `${Number(item.ls || 0).toFixed(2)} / ${item[needKey]}`;
    },
  },
};
</script>

<style lang="less" scoped>
.activity-hub {
  min-height: calc(100vh - 75px);
  padding: 30px 26px 70px;
  color: #f2f5ff;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 123, 31, 0.18), transparent 35%),
    radial-gradient(circle at 82% 28%, rgba(0, 223, 255, 0.12), transparent 28%),
    linear-gradient(180deg, #1d202c 0%, #1b1d28 48%, #181a24 100%);
}

button {
  font-family: inherit;
}

.hero-card {
  max-width: 1280px;
  min-height: 330px;
  margin: 0 auto 22px;
  padding: 42px 54px;
  position: relative;
  display: grid;
  grid-template-columns: 1.25fr 0.75fr;
  gap: 30px;
  overflow: hidden;
  border: 1px solid rgba(255, 132, 31, 0.32);
  border-radius: 22px;
  background:
    linear-gradient(135deg, rgba(37, 40, 55, 0.94), rgba(25, 27, 38, 0.94)),
    url("../../assets/new/task_bg.png") center / cover;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.38);
}

.hero-card::before {
  content: "";
  width: 520px;
  height: 520px;
  position: absolute;
  right: -90px;
  top: -160px;
  background: radial-gradient(circle, rgba(255, 122, 25, 0.38), transparent 64%);
}

.hero-copy {
  position: relative;
  z-index: 1;
}

.eyebrow,
.block-head span {
  color: #ff8a1f;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.hero-copy h1 {
  margin: 14px 0 16px;
  font-size: 56px;
  line-height: 1;
  font-weight: 1000;
}

.hero-copy p {
  max-width: 560px;
  margin: 0;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
}

.hero-actions {
  margin-top: 34px;
  display: flex;
  gap: 14px;
}

.hero-actions button,
.promo-card button,
.notice-card button {
  height: 46px;
  padding: 0 24px;
  color: #fff;
  background: linear-gradient(180deg, #ff9b20, #f16b00);
  border: 0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(241, 107, 0, 0.28);
}

.hero-actions .ghost {
  color: #d6e1f2;
  background: #2d3141;
  box-shadow: none;
}

.hero-panel {
  min-height: 250px;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.hero-panel img {
  width: 210px;
  height: 160px;
  object-fit: contain;
  filter: drop-shadow(0 30px 42px rgba(255, 126, 24, 0.36));
}

.panel-orbit {
  width: 290px;
  height: 145px;
  position: absolute;
  top: 76px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 186, 90, 0.2), transparent 64%);
  border-bottom: 1px solid rgba(255, 205, 136, 0.38);
}

.hero-panel strong {
  margin-top: 18px;
  color: #fff4d0;
  font-size: 22px;
}

.hero-panel em {
  margin-top: 8px;
  color: #99a2b5;
  font-style: normal;
}

.quick-grid,
.reward-layout,
.promo-section,
.notice-card {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.quick-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 26px;
}

.welfare-section {
  max-width: 1280px;
  margin: 0 auto 26px;
  padding: 24px;
  border: 1px solid #34384b;
  border-radius: 16px;
  background: linear-gradient(180deg, #252838, #20222e);
}

.welfare-section .section-title { display: flex; align-items: center; gap: 12px; }
.welfare-section .section-title > span { width: 4px; height: 46px; background: linear-gradient(#ffd25f, #ff7600); border-radius: 8px; }
.welfare-section h2 { margin: 0; color: #f5f7ff; font-size: 24px; }
.welfare-section p { margin: 6px 0 0; color: #9ea8bc; font-size: 13px; }
.welfare-grid { margin-top: 20px; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.welfare-box { min-height: 112px; padding: 14px; display: grid; grid-template-columns: 84px 1fr auto; align-items: center; gap: 12px; border: 1px solid rgba(255,255,255,.06); border-radius: 10px; background: #2b2e3e; }
.welfare-box.ready { border-color: rgba(255,188,62,.55); box-shadow: 0 0 24px rgba(255,150,0,.14); }.welfare-box.claimed { opacity: .62; }
.welfare-box img { width: 80px; height: 74px; object-fit: contain; filter: drop-shadow(0 12px 14px rgba(0,0,0,.34)); }.welfare-box strong,.welfare-box span,.welfare-box em { display: block; }.welfare-box strong { color:#f4f6ff; }.welfare-box span { margin-top:6px;color:#9ea8bc;font-size:12px; }.welfare-box em { margin-top:6px;color:#ffd363;font-size:13px;font-style:normal;font-weight:900; }.welfare-box button { min-width:62px;height:34px;color:#171923;border:0;border-radius:5px;background:linear-gradient(180deg,#ffd04a,#ff8b00);font-weight:1000;cursor:pointer; }.welfare-box button:disabled { color:#8e97aa;background:#3b3e4c;cursor:default; }

.quick-card {
  min-height: 146px;
  padding: 22px;
  text-align: left;
  background: #252838;
  border: 1px solid #34384b;
  border-radius: 16px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.quick-card::after {
  content: "";
  width: 150px;
  height: 150px;
  position: absolute;
  right: -52px;
  bottom: -68px;
  border-radius: 50%;
  opacity: 0.26;
}

.quick-card.orange::after {
  background: #ff7a00;
}

.quick-card.cyan::after {
  background: #00d8ff;
}

.quick-card.green::after {
  background: #2bed91;
}

.quick-card.pink::after {
  background: #ff4785;
}

.quick-icon {
  width: 28px;
  height: 28px;
  display: block;
  background: #ff8a1f;
  mask-size: contain;
  mask-position: center;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
}

.quick-card strong {
  display: block;
  margin: 18px 0 9px;
  color: #fff;
  font-size: 20px;
}

.quick-card em {
  color: #9da6b9;
  font-size: 13px;
  line-height: 1.6;
  font-style: normal;
}

.promo-section {
  margin-bottom: 26px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.section-title span {
  width: 8px;
  height: 8px;
  background: #ff8a1f;
  border-radius: 50%;
  box-shadow: 0 0 16px #ff8a1f;
}

.section-title h2 {
  margin: 0;
  font-size: 24px;
}

.promo-list {
  display: grid;
  gap: 14px;
}

.promo-card,
.notice-card,
.empty-card {
  padding: 22px 24px;
  border-radius: 16px;
  background: #242737;
  border: 1px solid #34384b;
}

.promo-card,
.notice-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.promo-card strong,
.notice-card strong {
  font-size: 19px;
}

.promo-card p,
.notice-card p {
  margin: 8px 0 0;
  color: #9da6b9;
}

.hot-dot {
  width: 8px;
  height: 8px;
  margin-right: 9px;
  display: inline-block;
  background: #ff8a1f;
  border-radius: 50%;
  box-shadow: 0 0 16px #ff8a1f;
}

.hot-dot.cyan {
  background: #00d8ff;
  box-shadow: 0 0 16px #00d8ff;
}

.empty-card {
  color: #9da6b9;
}

.welfare-tier-section {
  max-width: 1540px;
  margin: 0 auto 26px;
}

.welfare-tier-section .section-title p {
  margin: 7px 0 0;
  color: #9da6b9;
  font-size: 13px;
  line-height: 1.6;
}

.welfare-tier-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 10px;
}

.welfare-tier-grid article {
  min-height: 206px;
  padding: 14px 12px;
  display: grid;
  align-content: center;
  justify-items: center;
  text-align: center;
  border: 1px solid #34384b;
  border-radius: 12px;
  background: linear-gradient(180deg, #2a2d3d, #20232f);
  position: relative;
  overflow: hidden;
  outline: none;
}

.welfare-tier-grid article.reached {
  border-color: rgba(255, 181, 58, 0.54);
  box-shadow: inset 0 0 26px rgba(255, 144, 21, 0.1), 0 12px 28px rgba(0, 0, 0, 0.16);
}

.welfare-tier-grid span {
  color: #7e879c;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: .14em;
}

.welfare-tier-art {
  width: 138px;
  height: 112px;
  margin: 7px 0;
  position: relative;
}

.welfare-tier-art img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.welfare-tier-bg {
  opacity: .72;
  mix-blend-mode: screen;
}

.welfare-tier-case {
  z-index: 1;
  filter: drop-shadow(0 12px 14px rgba(0, 0, 0, .32));
}

.welfare-tier-grid strong {
  color: #ffe2a2;
  font-size: 16px;
}

.welfare-tier-grid em {
  margin-top: 6px;
  color: #9da6b9;
  font-size: 11px;
  font-style: normal;
  line-height: 1.45;
}

.welfare-tier-preview {
  position: absolute;
  inset: 0;
  z-index: 4;
  padding: 12px;
  display: grid;
  align-content: start;
  gap: 9px;
  overflow-y: auto;
  text-align: left;
  background: rgba(20, 22, 31, .97);
  opacity: 0;
  transform: translateY(10px);
  pointer-events: none;
  transition: opacity .18s ease, transform .18s ease;
}

.welfare-tier-grid article:hover .welfare-tier-preview,
.welfare-tier-grid article:focus .welfare-tier-preview {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.welfare-tier-preview > b {
  color: #ffd77d;
  font-size: 12px;
}

.welfare-tier-preview > p {
  margin: 20px 0 0;
  color: #9da6b9;
  font-size: 12px;
  text-align: center;
}

.welfare-tier-skins {
  display: grid;
  gap: 6px;
}

.welfare-tier-skins > span {
  min-height: 42px;
  padding: 5px 7px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  border: 1px solid rgba(255,255,255,.06);
  border-radius: 7px;
  background: rgba(255,255,255,.035);
  letter-spacing: 0;
}

.welfare-tier-skins img {
  width: 40px;
  height: 32px;
  object-fit: contain;
}

.welfare-tier-skins i {
  color: #e7eaf3;
  font-size: 10px;
  font-style: normal;
  line-height: 1.3;
}

.welfare-tier-skins strong {
  color: #ffb23c;
  font-size: 10px;
}

.welfare-result-mask {
  position: fixed;
  inset: 0;
  z-index: 2200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(6, 7, 12, .78);
  backdrop-filter: blur(7px);
}

.welfare-result-card {
  width: 460px;
  max-width: 100%;
  padding: 34px;
  position: relative;
  text-align: center;
  border: 1px solid rgba(255, 181, 58, .46);
  border-radius: 18px;
  background: radial-gradient(circle at 50% 18%, rgba(255, 143, 28, .22), transparent 38%), #242633;
  box-shadow: 0 30px 90px rgba(0, 0, 0, .58);
}

.welfare-result-card > span { color: #ffad38; font-size: 12px; font-weight: 900; letter-spacing: .16em; }
.welfare-result-card > img { width: 230px; height: 170px; margin: 18px auto 4px; display: block; object-fit: contain; filter: drop-shadow(0 24px 28px rgba(0, 0, 0, .52)); }
.welfare-result-card h3 { margin: 10px 0 6px; color: #fff; font-size: 24px; }
.welfare-result-card p { margin: 0 0 22px; color: #aab1c2; }
.welfare-result-card > div { display: flex; gap: 10px; justify-content: center; }
.welfare-result-card > div button { height: 40px; padding: 0 20px; color: #1b1308; border: 0; border-radius: 7px; background: linear-gradient(180deg, #ffd56d, #ff8b1f); font-weight: 900; cursor: pointer; }
.welfare-result-card > div button.muted { color: #d3d7e2; border: 1px solid #474b5e; background: #303341; }
.welfare-result-close { width: 34px; height: 34px; position: absolute; right: 14px; top: 14px; color: #fff; border: 0; border-radius: 50%; background: rgba(255, 255, 255, .08); font-size: 22px; cursor: pointer; }

.welfare-tier-grid article.reached em {
  color: #7fe5b5;
}

.reward-layout {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 26px;
}

.reward-block {
  padding: 24px;
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(42, 45, 61, 0.96), rgba(31, 34, 48, 0.96)),
    radial-gradient(circle at 30% 0, rgba(255, 138, 31, 0.12), transparent 42%);
  border: 1px solid #34384b;
}

.block-head {
  margin-bottom: 18px;
}

.block-head h3 {
  margin: 6px 0 0;
  font-size: 24px;
}

.sign-summary {
  height: 98px;
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: radial-gradient(circle, rgba(255, 138, 31, 0.18), rgba(32, 35, 48, 0.8) 70%);
}

.sign-summary strong {
  color: #ffbf64;
  font-size: 40px;
  line-height: 1;
}

.sign-summary em {
  margin-top: 7px;
  color: #9da6b9;
  font-style: normal;
}

.reward-row {
  min-height: 50px;
  display: grid;
  grid-template-columns: 1.2fr 0.7fr 0.7fr;
  gap: 12px;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
}

.reward-row span {
  color: #c6cedd;
}

.reward-row strong {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #fff4d0;
}

.reward-row i {
  width: 13px;
  height: 13px;
  display: inline-block;
  background: url("../../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.reward-row em {
  padding: 6px 8px;
  justify-self: end;
  border-radius: 7px;
  font-style: normal;
  font-size: 12px;
  font-weight: 900;
}

.reward-row .ready {
  color: #222;
  background: #ffbf64;
}

.reward-row .done {
  color: #b8c0d0;
  background: #34384b;
}

.reward-row .locked {
  color: #79e6ff;
  background: rgba(0, 216, 255, 0.1);
}

.notice-card {
  border-color: rgba(0, 216, 255, 0.24);
  background:
    radial-gradient(circle at 12% 0, rgba(0, 216, 255, 0.16), transparent 36%),
    #242737;
}

@media screen and (max-width: 980px) {
  .hero-card,
  .quick-grid,
  .reward-layout {
    grid-template-columns: 1fr;
  }

  .hero-card {
    padding: 34px 24px;
  }

  .hero-copy h1 {
    font-size: 42px;
  }

  .promo-card,
  .notice-card {
    align-items: flex-start;
    flex-direction: column;
  }

  .welfare-tier-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media screen and (max-width: 640px) {
  .activity-hub {
    padding: 18px 12px 42px;
  }

  .hero-actions {
    flex-direction: column;
  }

  .reward-row {
    grid-template-columns: 1fr;
    padding: 12px 0;
  }

  .reward-row em {
    justify-self: start;
  }

  .welfare-tier-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>

<style lang="less">
.activity-hub {
  min-height: calc(100vh - 198px) !important;
  padding: 32px 28px 96px !important;
}

.activity-hub .hero-card,
.activity-hub .quick-grid,
.activity-hub .promo-section,
.activity-hub .reward-layout,
.activity-hub .notice-card {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.activity-hub .hero-card {
  min-height: 430px !important;
  padding: 0 !important;
  display: block !important;
  border-color: rgba(255, 132, 31, 0.28) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.pk-promotion-hero {
  background:
    radial-gradient(ellipse at 22% 46%, rgba(255, 112, 0, 0.2), transparent 27%),
    radial-gradient(ellipse at 78% 0, rgba(146, 74, 230, 0.22), transparent 35%),
    linear-gradient(110deg, #222532 0%, #1d202c 48%, #252238 100%) !important;
}

.pk-promotion-hero::before {
  width: 680px !important;
  height: 680px !important;
  right: -180px !important;
  top: -380px !important;
  opacity: .65;
}

.pk-promotion-kicker {
  height: 42px;
  padding: 0 26px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #dfe4f1;
  border-bottom: 1px solid rgba(255, 255, 255, .07);
  font-size: 12px;
  font-weight: 900;
  letter-spacing: .16em;
}

.pk-promotion-kicker span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ff7900;
  box-shadow: 0 0 13px #ff7900;
}

.pk-promotion-showcase {
  min-height: 286px;
  padding: 20px 62px 12px;
  display: grid;
  grid-template-columns: 270px minmax(280px, 1fr) 126px;
  align-items: center;
  gap: 28px;
  position: relative;
  z-index: 1;
}

.pk-promotion-case {
  height: 248px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 18px;
  background:
    radial-gradient(circle at 50% 52%, rgba(255, 131, 0, .28), transparent 40%),
    radial-gradient(ellipse at 50% 95%, rgba(255, 82, 0, .38), transparent 42%);
}

.pk-promotion-case::before {
  content: "";
  width: 208px;
  height: 84px;
  position: absolute;
  bottom: 20px;
  border-radius: 50%;
  border: 1px solid rgba(255, 193, 104, .42);
  box-shadow: 0 0 45px rgba(255, 119, 0, .42), inset 0 0 28px rgba(255, 119, 0, .25);
  transform: perspective(100px) rotateX(55deg);
}

.pk-promotion-case img {
  width: 236px;
  height: 202px;
  position: relative;
  z-index: 1;
  object-fit: contain;
  filter: drop-shadow(0 26px 25px rgba(0, 0, 0, .54)) drop-shadow(0 0 22px rgba(255, 128, 0, .35));
  animation: pk-promotion-case-float 4.5s ease-in-out infinite;
}

.pk-promotion-spark {
  position: absolute;
  z-index: 2;
  border-radius: 50%;
  background: #ffd07b;
  box-shadow: 0 0 14px 4px rgba(255, 132, 0, .8);
}

.spark-one { width: 5px; height: 5px; top: 43px; left: 60px; }
.spark-two { width: 4px; height: 4px; right: 42px; bottom: 70px; }

.pk-promotion-price {
  position: absolute;
  z-index: 2;
  top: 17px;
  left: 21px;
  color: #ffd36e;
  font-size: 18px;
  font-weight: 1000;
}

.pk-promotion-price i {
  width: 13px;
  height: 13px;
  margin-left: 4px;
  display: inline-block;
  vertical-align: -1px;
  background: url("../../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-promotion-copy > span {
  color: #ff961f;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: .18em;
}

.pk-promotion-copy h1 {
  margin: 7px 0 11px;
  color: #f7f8fd;
  font-size: 34px;
  line-height: 1.1;
}

.pk-promotion-copy p {
  max-width: 520px;
  margin: 0;
  color: #aeb5c7;
  font-size: 14px;
  line-height: 1.7;
}

.pk-promotion-meta {
  margin-top: 19px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
}

.pk-promotion-meta b { color: #f1d5a3; }
.pk-promotion-meta em { color: #7a859b; font-style: normal; }

.pk-promotion-join,
.pk-deposit-banner button {
  height: 44px;
  color: #2a210f;
  border: 1px solid #ffe5a7;
  border-radius: 6px;
  background: linear-gradient(180deg, #ffe0a0, #ffb22e);
  font-size: 14px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 10px 26px rgba(255, 133, 0, .18);
}

.pk-promotion-join:disabled {
  color: #d9cfba;
  background: rgba(37, 40, 54, .9);
  border-color: rgba(255, 231, 180, .62);
  box-shadow: none;
}

.pk-deposit-banner {
  min-height: 88px;
  padding: 0 62px;
  display: grid;
  grid-template-columns: 260px minmax(220px, 1fr) 112px;
  align-items: center;
  gap: 20px;
  border-top: 1px solid rgba(255, 255, 255, .08);
  background: linear-gradient(90deg, rgba(255, 111, 0, .12), rgba(114, 67, 184, .16));
}

.pk-deposit-banner div { display: grid; gap: 4px; }
.pk-deposit-banner span { color: #ff9622; font-size: 11px; font-weight: 900; letter-spacing: .12em; }
.pk-deposit-banner strong { color: #fff2d0; font-size: 18px; }
.pk-deposit-banner p { margin: 0; color: #b4bbcc; font-size: 13px; line-height: 1.55; }

@keyframes pk-promotion-case-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

.activity-hub .quick-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  gap: 16px !important;
}

.activity-hub .promo-card,
.activity-hub .reward-block,
.activity-hub .quick-card,
.activity-hub .notice-card {
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.activity-hub .reward-layout {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 16px !important;
}

.activity-hub .reward-row {
  min-height: 58px !important;
}

@media screen and (max-width: 980px) {
  .activity-hub {
    padding: 18px 12px 58px !important;
  }

  .activity-hub .hero-card,
  .activity-hub .quick-grid,
  .activity-hub .promo-section,
  .activity-hub .reward-layout,
  .activity-hub .notice-card {
    width: 100% !important;
  }

  .activity-hub .quick-grid,
  .activity-hub .reward-layout {
    grid-template-columns: 1fr !important;
  }

  .pk-promotion-showcase,
  .pk-deposit-banner {
    padding-left: 24px;
    padding-right: 24px;
  }

  .pk-promotion-showcase {
    grid-template-columns: 220px 1fr 110px;
  }
}

@media screen and (max-width: 680px) {
  .activity-hub .hero-card { min-height: 0 !important; }
  .pk-promotion-showcase { grid-template-columns: 1fr; gap: 10px; padding-top: 10px; }
  .pk-promotion-case { height: 190px; }
  .pk-promotion-case img { width: 188px; height: 164px; }
  .pk-promotion-join { width: 100%; }
  .pk-deposit-banner { padding: 18px 24px; grid-template-columns: 1fr; }
}
</style>

<style lang="less">
/* 2026-10-01 mobile interaction pass: keep welfare content visible and tappable. */
@media screen and (max-width: 680px) {
  .activity-hub {
    width: 100% !important;
    max-width: 100vw !important;
    padding: 14px 12px calc(104px + env(safe-area-inset-bottom)) !important;
    overflow-x: hidden !important;
    box-sizing: border-box !important;
  }

  .activity-hub .welfare-section,
  .activity-hub .welfare-tier-section,
  .activity-hub .promo-section,
  .activity-hub .reward-layout,
  .activity-hub .notice-card {
    width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
  }

  .activity-hub .welfare-section,
  .activity-hub .reward-block,
  .activity-hub .promo-card,
  .activity-hub .notice-card {
    padding: 16px !important;
  }

  .activity-hub .section-title {
    align-items: flex-start;
  }

  .activity-hub .section-title h2,
  .activity-hub .welfare-section h2 {
    font-size: 21px;
  }

  .activity-hub .welfare-grid,
  .activity-hub .welfare-tier-grid {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .activity-hub .welfare-box {
    width: 100%;
    min-width: 0;
    padding: 12px;
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 10px;
    box-sizing: border-box;
  }

  .activity-hub .welfare-box img {
    width: 68px;
    height: 64px;
  }

  .activity-hub .welfare-box > div {
    min-width: 0;
  }

  .activity-hub .welfare-box button {
    width: 100%;
    min-width: 0;
    min-height: 44px;
    grid-column: 1 / -1;
    touch-action: manipulation;
  }

  .activity-hub .welfare-tier-grid article {
    width: 100%;
    min-width: 0;
    min-height: 0;
    padding: 14px;
    overflow: visible;
    box-sizing: border-box;
  }

  .activity-hub .welfare-tier-preview {
    width: 100%;
    max-height: 250px;
    margin-top: 12px;
    position: static;
    inset: auto;
    opacity: 1;
    transform: none;
    pointer-events: auto;
    border-radius: 8px;
    background: rgba(20, 22, 31, .78);
    box-sizing: border-box;
  }

  .activity-hub .welfare-tier-skins > span {
    grid-template-columns: 44px minmax(0, 1fr) auto;
  }

  .activity-hub .promo-card button,
  .activity-hub .notice-card button,
  .activity-hub .reward-row button,
  .activity-hub .welfare-result-card button,
  .activity-hub .pk-promotion-join,
  .activity-hub .pk-deposit-banner button {
    width: 100%;
    min-height: 44px;
    touch-action: manipulation;
  }

  .activity-hub .welfare-result-mask {
    padding: 12px 12px calc(88px + env(safe-area-inset-bottom));
  }

  .activity-hub .welfare-result-card {
    max-height: calc(100vh - 112px - env(safe-area-inset-bottom));
    padding: 24px 16px 18px;
    overflow-y: auto;
  }

  .activity-hub .welfare-result-card > img {
    width: 180px;
    height: 132px;
  }

  .activity-hub .welfare-result-card > div {
    flex-direction: column;
  }
}
</style>
